import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Typography,
  ListItem,
  Button,
  List,
  CircularProgress,
} from "@mui/material";
import { cityIOSettings } from "../../../../settings/settings";
import { useDispatch } from "react-redux";
import axios from "axios";
import {
  updateCityIOdata,
} from "../../../../redux/reducers/cityIOdataSlice";

export default function ScenariosMenu() {
  const [scenariosButtonsList, setScenariosButtonsList] = useState([]);
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentScenario, setCurrentScenario] = useState("PHASE 2");

  const dispatch = useDispatch();

  // get cityIO data from redux store
  const cityIOdata = useSelector((state) => state.cityIOdataState.cityIOdata);
  

  const fetchCityIOScenarios = async () => {
    const cityIOlistURL =
      cityIOSettings.cityIO.baseURL + cityIOSettings.cityIO.dump + cityIOdata.tableName;
    // get all table headers
    let tablesArr = await axios.get(cityIOlistURL);
    
    setScenarios((oldArray) => [...tablesArr.data]);
    setLoading(false);
};

  useEffect(() => {
    fetchCityIOScenarios();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  useEffect(() => {
    const handleOpenDialog = (scenario) => {
      
      let m = {...cityIOdata, "GEOGRID": scenario.data.GEOGRID, "GEOGRIDDATA":scenario.data.GEOGRIDDATA };

      Object.keys(scenario.data).forEach((key)=>{
        if(key === 'LAYERS'){
          m = {...m, "layers": scenario.data[key] };
        }
        else if(key === 'NUMERICINDICATORS'){
          m = {...m, "indicators": scenario.data[key] };
        }
      }
      );
      setCurrentScenario(scenario.name);
      dispatch(updateCityIOdata(m));
    };
  
    const scenariosButtons = scenarios.map((scenario, i) => {
      return (
        <ListItem key={`scenario_grid_item_${i}`} sx={{ width: "100%", padding: 0, marginTop: 2, marginBottom: 2}}>

            <Button
              fullWidth={true}
              key={"scenario_button_" + i}
              sx={{ width: "100%"
               }}
              size="large"
              variant={currentScenario === scenario.name ? "contained" : "outlined"}
              onClick={() => handleOpenDialog(scenario)}
            >
                  <Typography>
                    {scenario.name}
                  </Typography>
            </Button>

        </ListItem>
      );
    });
    setScenariosButtonsList(scenariosButtons)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scenarios,currentScenario]);


  return (
    <>
      {loading && <CircularProgress/>}
      <List sx={{ width: "100%" }}>{scenariosButtonsList}</List>

    </>
  );
}
